import ParticipantsControl from 'features/toolbar/toolbar/controls/participants/ParticipantsControl';
import ChatControl from 'features/toolbar/toolbar/controls/chat/ChatControl';
import QAControl from 'features/toolbar/toolbar/controls/qa/QAControl';
import RaiseHandControl from 'features/toolbar/toolbar/controls/raise-hand/RaiseHandControl';
import RecordingControl from 'features/toolbar/toolbar/controls/recording/RecordingControl';
import RestreamingControl from 'features/toolbar/toolbar/controls/restreaming/RestreamingControl';
import WhiteboardControl from 'features/toolbar/toolbar/controls/whiteboard/WhiteboardControl';
import OverflowMenu from 'components/OverflowMenu/OverflowMenu';
import { useParticipantsControl } from 'features/toolbar/toolbar/controls/participants/useParticipantsControl';
import { useChatControl } from 'features/toolbar/toolbar/controls/chat/useChatControl';
import { useQAControl } from 'features/toolbar/toolbar/controls/qa/useQAControl';
import { useRaiseHandControl } from 'features/toolbar/toolbar/controls/raise-hand/useRaiseHandControl';
import { useRecordingControl } from 'features/toolbar/toolbar/controls/recording/useRecordingControl';
import { useRestreamingControl } from 'features/toolbar/toolbar/controls/restreaming/useRestreamingControl';
import { useWhiteboardControl } from 'features/toolbar/toolbar/controls/whiteboard/useWhiteboardControl';
import React from 'react';
import { usePollsControl } from 'features/toolbar/toolbar/controls/polls/usePollsControl';
import PollsControl from 'features/toolbar/toolbar/controls/polls/PollsControl';
import TranscriptionControl from 'features/toolbar/toolbar/controls/transcription/TranscriptionControl';
import { useTranscriptionControl } from 'features/toolbar/toolbar/controls/transcription/useTranscriptionControl';
import { useContentLibraryControl } from 'features/toolbar/toolbar/controls/content-library/useContentLibraryControl';
import ContentLibraryControl from 'features/toolbar/toolbar/controls/content-library/ContentLibraryControl';
import SharedNotesControl from 'features/toolbar/toolbar/shared-notes/SharedNotesControl';
import { useSharedNotesControl } from 'features/toolbar/toolbar/shared-notes/useSharedNotesControl';
import { useSIPControl } from 'features/toolbar/toolbar/controls/sip/useSIPControl';
import SIPControl from 'features/toolbar/toolbar/controls/sip/SIPControl';
import RoomReactionsControl from 'features/toolbar/toolbar/controls/room-reactions/RoomReactionsControl';
import { useRoomReactionsControl } from 'features/toolbar/toolbar/controls/room-reactions/useRoomReactionsControl';

type OverflowMenuContainerProps = {
  leading: boolean;
};

const OverflowMenuContainer = React.memo(({ leading }: OverflowMenuContainerProps) => {
  const { isFeatureAvailable: participantsAvailable } = useParticipantsControl();
  const { isFeatureAvailable: chatAvailable } = useChatControl();
  const { isFeatureAvailable: qaAvailable } = useQAControl();
  const { isFeatureAvailable: contentLibraryAvailable } = useContentLibraryControl();
  const { isFeatureAvailable: raiseHandAvailable } = useRaiseHandControl();
  const { isFeatureAvailable: recordingAvailable } = useRecordingControl();
  const { isFeatureAvailable: restreamerAvailable } = useRestreamingControl();
  const { isFeatureAvailable: whiteboardAvailable } = useWhiteboardControl();
  const { isFeatureAvailable: pollsAvailable } = usePollsControl();
  const { isFeatureAvailable: transcriptionAvailable } = useTranscriptionControl();
  const { isFeatureAvailable: sharedNotesAvailable } = useSharedNotesControl();
  const { isFeatureAvailable: sipAvailable } = useSIPControl();
  const { isFeatureAvailable: roomReactionsAvailable } = useRoomReactionsControl();

  return (
    <OverflowMenu leading={leading}>
      {participantsAvailable && <ParticipantsControl />}
      {chatAvailable && <ChatControl />}
      {qaAvailable && <QAControl />}
      {pollsAvailable && <PollsControl />}
      {raiseHandAvailable && <RaiseHandControl />}
      {recordingAvailable && <RecordingControl />}
      {restreamerAvailable && <RestreamingControl />}
      {transcriptionAvailable && <TranscriptionControl />}
      {whiteboardAvailable && <WhiteboardControl />}
      {contentLibraryAvailable && <ContentLibraryControl />}
      {sharedNotesAvailable && <SharedNotesControl />}
      {sipAvailable && <SIPControl />}
      {roomReactionsAvailable && <RoomReactionsControl />}
    </OverflowMenu>
  );
});

export default OverflowMenuContainer;
